module.exports = __webpack_public_path__ + "img/7.4edd9673.jpg";